
// Элементы с оверлеем дополнительных аксессуаров
export const OVERLAY_ELEMENTS = [
    'Полка сетчатая',
    'Штанга',
    'Брючница выдвижная',
    'Обувница',
    'Полка ЛДСП',
    'Корзина мелкосетчатая',
    'Корзина пластиковая',
    'Полка-корзина',
    'Полка мелкосетчатая',
];

// Элементы с возможностью установки штанги
export const ROD_COMPATIBLE_ELEMENTS = [
    'Полка сетчатая',
    'Полка металлическая',
    'Полка-корзина',
    'Полка мелкосетчатая',
    'Полка ЛДСП',
];

export const ROD_COMPATIBLE_TYPES = [
    'shelf',
    'gridShelf',
    'ldsp',
    'gridShelfBasket',
];


// Привязки названий элементов к их типам
export const ELEMENT_TYPE_BINDINGS: Record<string, string> = {
    // Корзины
    'Корзина мелкосетчатая': 'basket',
    'Корзина пластиковая': 'basket',
    'Корзина': 'basket',

    // Брючницы
    'Брючница выдвижная': '',
    'Брючница': '',

    // Обувницы
    'Обувница': 'shoeRack',

    // Перфопанели
    'Перфопанель': 'panel',

    // Панели с крючками
    'Панель с крючками': 'panel',
    'GPS-60': 'panel',
    'GPS-90': 'panel',
    'GHS-60': 'panel',
    'GHS-90': 'panel',

    // Полки ЛДСП
    'Полка ЛДСП': 'ldsp',

    // Полки металлические
    'Полка металлическая': 'gridShelf',

    // Полки-корзины
    'Полка-корзина': 'gridShelfBasket',

    // Полки мелкосетчатые
    'Полка мелкосетчатая': 'gridShelf',

    // Полки сетчатые
    'Полка сетчатая': 'gridShelf',

    // Штанги
    'Штанга': '',

    // Рамы выдвижные
    'Рама выдвижная': '',
};

// Функция для получения типа элемента по названию
export function getElementTypeByName(name: string): string {
    // Проверяем точные совпадения
    for (const [ key, value ] of Object.entries(ELEMENT_TYPE_BINDINGS)) {
        if (name.includes(key)) {
            return value;
        }
    }

    return '';
}

export function isRodAvailableByName(name: string): boolean {
    return ROD_COMPATIBLE_ELEMENTS.some((el)=>name.includes(el));
}